//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import addressManage from './addressManage.vue'
export default {
    props: {
        isCheck: {
            default: false
        }
    },
    data() {
        return {
            addressManageShow: false,
            list: []
        }
    },
    components: {
        addressManage
    },
    computed: {
        token() {
            return this.$store.state.token;
        }
    },
    watch: {
        token(newVal) {
            if(newVal) {
                this.loadList();
            } else {
                this.list = [];
            }
        }
    },
    methods: {
        //返回按钮
        preventGoBackHandle(address) {
            if(this.isCheck) {
                this.$emit('goBack', address);
            } else {
                this.$router.go(-1);
            }
        },
        //选择地址
        onItemClick(item) {
            if(this.isCheck) {
                this.preventGoBackHandle(item);
            }
        },
        toAddressManage(type, item) {
            this.$refs.addressManageRef.showPopup(type, item);
        },
        loadList() {
            this.$emit("loadAddressList"); // 重置立即购买页地址栏
            let that = this;
            that.$axios.get("/api/v1.0/lonbonShop/receiverAddress", {
                params: {
                    shopperId: that.$store.state.userInfo.shopperId
                }
            }).then(function (res) {
                if (res.status == 200) {
                    that.list = res.body.map((item) => {
                        item.title = item.name + ' ' + item.phoneNum;
                        item.desc = item.regionDesc.replace(/\s/g,"") + item.address;
                        return item;
                    });
                }
            })
        }
    },
    mounted() {
        this.loadList();
    }
}



// WEBPACK FOOTER //
// ./src/components/address/list.vue